import { MilestoneAgentName } from '@thoughtspot/blink-context';
import { AgentId } from '@thoughtspot/sparkflow';
import { TourPersonaPrefix } from './checklist-tour/checklist-tour-steps.util';

export const TOUR_CARD_Z_INDEX = 300;
export const TOUR_CARD_WIDTH = 375;

export enum MilestoneCtaActionType {
    Dismiss = 'dismiss',
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
}

export interface AgentMilestoneConfig {
    agentName: MilestoneAgentName;
    sectionId: TourPersonaPrefix;
}

export const AGENT_SELECTION_MILESTONE_CONFIG: Partial<Record<
    AgentId,
    AgentMilestoneConfig
>> = {
    [AgentId.ASK_QUESTIONS]: {
        agentName: MilestoneAgentName.SPOTTER_CHAT,
        sectionId: TourPersonaPrefix.SPOTTER_CHAT,
    },
    [AgentId.BUILD_DASHBOARD]: {
        agentName: MilestoneAgentName.SPOTTER_VIZ,
        sectionId: TourPersonaPrefix.SPOTTER_VIZ,
    },
    [AgentId.EMBED_INSIGHTS]: {
        agentName: MilestoneAgentName.SPOTTER_CODE,
        sectionId: TourPersonaPrefix.EMBED_WITH_SPOTTERCODE,
    },
};

/* Fallback section ID used when no entry is found in
 * MILESTONE_SECOND_SECTION_BY_AGENT for the current agent selection. */
export const EXPLORE_DASHBOARDS_SECTION_ID =
    TourPersonaPrefix.EXPLORE_DASHBOARDS;

/* Maps each agent selection to the section that must also be complete
 * before Milestone 2 (onboarding complete) fires.
 * Spotter/SpotterViz require Dashboards; SpotterCode requires SpotterViz. */
export const MILESTONE_SECOND_SECTION_BY_AGENT: Partial<Record<
    AgentId,
    TourPersonaPrefix
>> = {
    [AgentId.ASK_QUESTIONS]: TourPersonaPrefix.EXPLORE_DASHBOARDS,
    [AgentId.BUILD_DASHBOARD]: TourPersonaPrefix.EXPLORE_DASHBOARDS,
    [AgentId.EMBED_INSIGHTS]: TourPersonaPrefix.SPOTTER_VIZ,
};
